module.exports = __webpack_public_path__ + "img/import2.c2c514e3.svg";